import validator from 'validator';

export function updateField(event) {
  const field = event.target.name;
  const value = event.target.value;
  const updatedFields = this.state.fields;

  if (field === 'name') {
    updatedFields[field].valid = !validator.isEmpty(value);
  }

  if (field === 'email') {
    updatedFields.email.valid =
      validator.isEmail(value) && !validator.isEmpty(value);
  }

  if (field === 'phone') {
    updatedFields.phone.valid =
      validator.isMobilePhone(value) && !validator.isEmpty(value);
  }

  updatedFields[field].value = value;

  this.setState({
    fields: updatedFields,
  });
}

export function flashFeedback(feedback) {
  const newFeedback = [feedback];

  this.setState(
    {
      feedback: newFeedback,
      showFeedback: true,
    },
    () => setTimeout(this.hideFeedback, 5000)
  );
}

export function hideFeedback() {
  this.setState({
    feedback: [],
    showFeedback: false,
  });
}

export function handleFetchErrors(responses) {
  responses.forEach((response) => {
    if (!response?.value?.ok) {
      this.setState({
        hasErrors: true,
      });

      throw Error(response?.value?.statusText || 'Form submission failed');
    }
  });

  return responses;
}

export function handleSubmit(event) {
  event.preventDefault();

  // Prevent multiple submissions
  if (this.state.isSubmitting) {
    return;
  }

  const validForm = Object.keys(this.state.fields).every(
    (field) => this.state.fields[field].valid
  );

  this.setState({
    submitted: true,
  });

  if (!validForm) {
    return;
  }

  // Lock the submit button
  this.setState({
    isSubmitting: true,
  });

  const formData = new FormData(event.target);
  const formName = event.target.getAttribute('name');

  const payload = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams(formData).toString(),
    credentials: 'same-origin',
  };

  Promise.allSettled([
    fetch('/api/mailer', payload),
    fetch('/api/tracker', payload),
    fetch('/', payload),
  ])
    .then(this.handleFetchErrors)
    .then(() => {
      this.setState(
        {
          hasErrors: false,
          isSubmitting: false,
        },
        () => {
          this.triggerEvent(
            'formSubmitted',
            'RYNO LP Conversion',
            formName
          );
          this.flashFeedback('Form Submitted Successfully!');
          this.resetForm();
        }
      );
    })
    .catch(() => {
      this.setState(
        {
          hasErrors: true,
          isSubmitting: false,
        },
        () => {
          this.flashFeedback('Form Submission Error!');
        }
      );
    });
}

export function resetForm() {
  const resetFields = this.state.fields;

  Object.keys(resetFields).forEach((field) => {
    resetFields[field].value = '';
    resetFields[field].valid = false;
  });

  // Optional fields should remain valid after reset
  resetFields.newCustomer.valid = true;
  resetFields.message.valid = true;

  this.setState(
    {
      fields: resetFields,
      submitted: false,
      hasErrors: false,
      isSubmitting: false,
    },
    () => {
      this.domRef.current.reset();
    }
  );
}

export function toggleValidationBox(field) {
  return !this.state.fields[field].valid && this.state.submitted
    ? 'inline-block'
    : 'hidden';
}

export function triggerEvent(action, category, label) {
  try {
    if (window.dataLayer !== undefined) {
      window.dataLayer.push({
        event: action,
        category,
        label,
      });
    }
  } catch (error) {
    console.error(error);
  }
}